// extracted by mini-css-extract-plugin
export default {"mainContainer":"ProfileView_mainContainer__0UXhh","drinkList":"ProfileView_drinkList__Wfmgv"};